import { render, staticRenderFns } from "./SkillDetailPopup.vue?vue&type=template&id=193df3c4&scoped=true"
import script from "./SkillDetailPopup.vue?vue&type=script&lang=js"
export * from "./SkillDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./SkillDetailPopup.vue?vue&type=style&index=0&id=193df3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193df3c4",
  null
  
)

export default component.exports